// extracted by mini-css-extract-plugin
module.exports = {"announcementContainer":"_03aada9","date":"_12e6a5c","username":"_e826f44","announcement":"_3c55767","announcementInfo":"_75157b8"};